// extracted by mini-css-extract-plugin
export default {"loader":"Notes_loader__mMO+6","editor":"Notes_editor__sJQfA"};